import React, { useState } from 'react'
import {
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Icon,
} from '@chakra-ui/react'
import { BiRefresh } from 'react-icons/bi'
import { BsPatchQuestion } from 'react-icons/bs'

const Help = ({isFirstRun, onClosePopOver}) => {
  const [isOpen, setIsOpen] = useState(isFirstRun);
  const open = () => setIsOpen(!isOpen)
  const close = () => {
    setIsOpen(false);
    onClosePopOver();
  }
  return (
    <>
      <Popover isOpen={isOpen} onClose={close} placement='bottom-end' arrowSize={12}>
      <PopoverTrigger>
      <IconButton onClick={open} isRound variant={'ghost'} aria-label='Help' icon={<BsPatchQuestion/>}/>
      </PopoverTrigger>
      <PopoverContent >
        <PopoverHeader fontWeight='semibold'>Help</PopoverHeader>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>
          A set of 5 multiple-choice trivia questions of varying difficulty.<br/><br/>
          Select the answer for each question and then click on <b>Check Result</b> to check your score<br/><br/>
          Use the <Icon as={BiRefresh}/> button to swap out a question for a different one.
          You get only <b>ONE</b> swap per set. Use it wisely!<br/><br/>

        </PopoverBody>
        <PopoverFooter>
          A new set is available each day!
        </PopoverFooter>
      </PopoverContent>
    </Popover>
    </>
  )
}

export default Help
